import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FlowChartDialogComponent } from '../../flow-chart-dialog/flow-chart-dialog.component';
import { RouteOption, routeOptions } from '../../interfaces/data/delegate';
import { MrpScrolltopComponent } from '../../services/mrp-scrolltop/mrp-scrolltop.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';

import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-stateparty',
    templateUrl: './stateparty.component.html',
    styleUrls: ['./stateparty.component.css'],
    imports: [MrpScrolltopComponent, MatFormField, MatLabel, MatSelect, MatOption, MatButton]
})
export class StatepartyComponent implements OnInit {


  delegateroutes: RouteOption[] = routeOptions; 
  isBrowser = false;

  constructor(private dialog: MatDialog, private router: Router, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) this.logPage('stateparty');
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }

  openFlowChartDialog(): void {

    if (window.innerWidth < 1000) {
      const dialogRef = this.dialog.open(FlowChartDialogComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        panelClass: 'full-screen-dialog'
      });

      dialogRef.afterOpened().subscribe(() => {
        // Logic to handle when the dialog is opened, if needed
      });
    }
  
  }

  selectedPageText: string = 'Additional Topics';

  onPageSelected(pageName: string): void {
    this.selectedPageText = pageName;
  }

  onRouteSelect(path: string): void {
    if (path) {
      this.router.navigate([path]);
    }
  }

}
